import { BrowserRouter } from 'react-router-dom'
import Layout from '@/layout'
import { useRoutes } from 'react-router-dom'
import { allRoutes } from '@/route'
import { useEffect, useState } from 'react'
import { Button, Result, Spin } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import getFrontUrl, { invalidateFrontUrlRequests } from '@/utils/getFrontUrl'

const GetRoutes = () => useRoutes(allRoutes)

function App() {
  const { t } = useTranslation()
  const [frontStatus, setFrontStatus] = useState<'loading' | 'ready' | 'failed'>('loading')
  const [attempt, setAttempt] = useState(0)

  useEffect(() => {
    let cancelled = false
    setFrontStatus('loading')
    void getFrontUrl().then((ready) => {
      if (!cancelled) setFrontStatus(ready ? 'ready' : 'failed')
    })
    // 浏览器标识相关
    const _agent = navigator.userAgent.toLowerCase()
    if (/safari/.test(_agent) && !/chrome/.test(_agent)) {
      document.documentElement.dataset.safari = `1`
    } else {
      document.documentElement.dataset.safari = `0`
    }
    return () => {
      cancelled = true
      invalidateFrontUrlRequests()
    }
  }, [attempt])
  return (
    <BrowserRouter>
      {frontStatus === 'ready' ? (
        <Layout>
          <GetRoutes />
        </Layout>
      ) : (
        <div
          role="status"
          style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', padding: 24 }}
        >
          {frontStatus === 'failed' ? (
            <Result
              status="warning"
              title={t('frontUrlFailure', { defaultValue: 'Unable to load configuration.' })}
              extra={
                <Button icon={<ReloadOutlined />} onClick={() => setAttempt((value) => value + 1)}>
                  {t('frontUrlRetry', { defaultValue: 'Retry' })}
                </Button>
              }
            />
          ) : (
            <Spin size="large" />
          )}
        </div>
      )}
    </BrowserRouter>
  )
}

export default App
